import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { MeasureUniteService } from '../measure-unite.service';

@Component({
  selector: 'app-create-measure-of-unit',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    CheckboxModule
  ],
  templateUrl: './create-measure-of-unit.component.html'
})
export class CreateMeasureOfUnitComponent implements OnInit, OnDestroy {

  @Input() id!: number | null;
  @Output() formSubmitted = new EventEmitter<void>();
  @Output() modalClosed = new EventEmitter<void>();
  form!: FormGroup;

  constructor(private fb: FormBuilder, private service: MeasureUniteService){

  }
  
  ngOnDestroy(): void {
    this.modalClosed.emit();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      description: ['', Validators.required],
      acronym: ['', Validators.required],
      active: [true]
    });

    if(this.id)
    {
      this.getData();
    }
  }

  getData(){
    this.service.getById(this.id as number).subscribe({
      next: (data) => {
        this.form.patchValue(data.data);
    }, 
    error:() => {}
  });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return field ? field.invalid && (field.dirty || field.touched) : false;
  }

  onSubmit()
  {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        if (control) {
          control.markAsTouched();
        }
      });
      return;
    }

      if(this.id)
      {
        this.service.update(this.id, this.form.value).subscribe({
          next: (data) => 
          {
            this.formSubmitted.emit();
          },
          error: (error) => 
          {
            console.log(error);
          }
        })
      }else{
        this.service.create(this.form.value).subscribe({
          next: (data) => 
          {
            this.formSubmitted.emit();
          },
          error: (error) => 
          {
            console.log(error);
          }
        })
      }
  }
  
}
